module.exports = __webpack_public_path__ + "static/media/Test38.6fc0d412.bmp";